import { commonAttributes, tableColumnDefaultOption } from 'app/config'
import { validateNotEmpty } from 'app/validators'

import { PRESCHOOL_SKILL_TYPE_OPTIONS } from '../constants'

export const columns = [
  { ...commonAttributes.uuid },
  {
    name: 'name',
    label: 'Name',
    validate: validateNotEmpty,
    ...tableColumnDefaultOption
  },
  {
    name: 'type',
    label: 'Type',
    widget: 'select',
    validate: validateNotEmpty,
    valueLabelMappings: PRESCHOOL_SKILL_TYPE_OPTIONS,
    ...tableColumnDefaultOption
  },
  {
    name: 'order',
    label: 'Order',
    ...tableColumnDefaultOption
  },
  {
    name: 'code',
    label: 'Code',
    optional: true,
    ...tableColumnDefaultOption
  },
  {
    name: 'is_active',
    label: 'Active',
    widget: 'checkbox',
    // Active by default on create (mirrors the request builder's
    // `is_active !== false` default). Only applied on the create path; edit
    // uses the record's real boolean value.
    defaultValue: () => true,
    ...tableColumnDefaultOption
  }
]
